import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import { ViewStyle, StyleProp } from 'react-native';
import MessageInput from '../../../../../v2BaseComponents/MessageInput';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

const intl = getIntl('chatMessageInput', {
    placeholder: 'Ask anything...',
});

export type ChatMessageInputOwnProps = {
    onSend: (message: string) => void;
    isSendingMessage: boolean;
    isDisabled?: boolean;
    style?: StyleProp<ViewStyle>;
    testID?: string;
};

export type ChatMessageInputProps = ChatMessageInputOwnProps;

const ChatMessageInput: React.FC<ChatMessageInputProps> = ({ onSend, isSendingMessage, isDisabled, style, testID }) => {
    const isMobile = useIsMobileLayout();
    return (
        <MessageInput
            onSubmit={onSend}
            isLoading={isSendingMessage}
            isDisabled={isDisabled}
            style={style}
            testID={testID}
            placeholder={intl('placeholder')}
            focusOnMount={!isMobile}
        />
    );
};

export default React.memo(ChatMessageInput);
